import firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyBs9JlPAB1-7V0XzahWPUPCLKlAhXPWp98",
  authDomain: "clone-9bdad.firebaseapp.com",
  databaseURL: "https://clone-9bdad.firebaseio.com",
  projectId: "clone-9bdad",
  storageBucket: "clone-9bdad.appspot.com",
  messagingSenderId: "380430270183",
  appId: "1:380430270183:web:289a40b4ebf730dcc9ac42",
  measurementId: "G-NQH8BD6346"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebaseApp.auth();

export {db, auth};